import { Bus } from '@atlas/core';

export const scrollToTopHandler = behavior => {
  const validBehaviors = ['auto', 'smooth'];
  const scrollBehavior = validBehaviors.includes(behavior) ? behavior : 'smooth';

  Bus.emit('ui:scroll:content', {
    behavior: scrollBehavior,
    scrollTo: 0,
  });

  window.scrollTo({
    behavior: scrollBehavior,
    top: 0,
  });
};
